import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { Observable } from 'rxjs';


@Injectable()
export class HtmlPagesLinksService {

  constructor(private restApiService: RestApiService) { }

  getPrivacyPolicy(): Observable<any> {
    return this.restApiService.get('/tenant-privacy-policy', 'page-center');
  }
}

